import React from 'react';
import { NavLink  } from 'react-router-dom'
import { Query, withApollo } from "react-apollo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { clientCredentials, channelsUnread } from '../../graphql/queries'
import { ColError, ColLoading } from '../chunk'

class Header extends React.Component {

	constructor(props) {
		super(props);

        const titles = [
            'trashnet',
            'dashnet',
            'nashcat',
            'freshnet',
            'da trashnizzle',
        ]

		this.state = {
            title: titles[Math.floor(Math.random() * titles.length)],
			navOpen: false
		};

    	this.handleToggleNav = this.handleToggleNav.bind(this);
    	this.handleNav = this.handleNav.bind(this);
	}


	handleToggleNav(e) {
		var newVal = 1 - this.state.navOpen;
		this.setState({ navOpen: newVal });
	}


	handleNav(e) {
		if(e.target.tagName.toLowerCase() === 'a')
			this.setState({navOpen: false});
	}

	render() {
		return (
			<div className="head__wrap">
				<header className="head">
					<h1 className="head__title" onClick={this.handleToggleNav}><div className="fa-logo" /> {this.state.title}</h1>
					<button className="head__bars" onClick={this.handleToggleNav}></button>
				</header>
				<Query query={clientCredentials}>
					
			      	{({ data, client }) => {
			      		if(data.clientCredentials.id) {
			      			return (
								<nav className={this.state.navOpen ? 'nav' : 'nav nav--hidden'} onClick={this.handleNav}>
									<NavLink exact activeClassName="active" to='/'>Home</NavLink>
									<NavLink activeClassName="active" to='/users'>Users</NavLink>
									<div className="nav__divider"></div>
									<Query query={channelsUnread}>
									    {({ loading, error, data }) => {
									    	if( loading ) return (<ColLoading />)
											if( error ) return (<ColError error={error} />)
											return data.channelsUnread.map(({id, name, unreadCount}) => (
												<NavLink key={id} activeClassName="active" to={`/channels/${id}`}>
													{name.toUpperCase()}
													<span className={'nav__unread' + ((!unreadCount) ? ' nav__unread--hidden' : '')}>{unreadCount || 0}</span>
												</NavLink>
											));
										}}
									</Query>
									<div className="nav__divider"></div>
									<NavLink activeClassName="active" to='/mails'>Mail</NavLink>
									<NavLink activeClassName="active" to='/notes'>Notes</NavLink>
									<div className="nav__divider"></div>
									<NavLink activeClassName="active" to='/login'>Logout</NavLink>
								</nav>
				      		)
			      		} else {
			      			return (
			      				<nav className={this.state.navOpen ? 'nav' : 'nav nav--hidden'} onClick={this.handleNav}>
				      				<NavLink activeClassName="active" to='/login'>Login</NavLink>
				      				<NavLink activeClassName="active" to='/migrate'>Migrate old user</NavLink>
				      				<NavLink activeClassName="active" to='/checkin'>Forgot password?</NavLink>
				      			</nav>
			      			)
			      		}
			      	}}
				</Query>

                <div></div>
			</div>
		)
	}
};


export default withApollo(Header);


// WEBPACK FOOTER //
// ./src/components/chunk/Header.js